import http from '../utils/api'

const assetApi = 'assets';

const getAssetsOnSite = function(siteId) {
    return http.get(assetApi + '/onSite/' + siteId);
};

const getAssetsOnLocation = function(locationId) {
    return http.get(assetApi + '/onlocation', { params: { locationId: locationId } });
};

const read = function(id) {
    return http.get(assetApi + '/' + id);
}

const getImage = function(id) {
    return http.get(`${assetApi}/${id}/image`);
}

export const assetService = {
    getAssetsOnSite,
    getAssetsOnLocation,
    read,
    getImage
};